define('components/course/models/theme',[], function () {
    "use strict";

    return Backbone.Model.extend({
        "defaults": {
            "guid": null,
            "url": null,
            "sectionIndex": null,
            "slideIndex": null
        },

        "getAvatar": function () {
            return this.get('url') + 'avatar.png';
        },

        "getBackground": function () {
            return this.get('url') + 'background.png';
        },

        "getThumbnail": function () {
            return this.get('url') + 'thumbnail.png';
        }
    });
});

